<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import ActiveCampaign from "@/components/tools/modals/ActiveCampaign.vue";
import LeadLovers from "@/components/tools/modals/LeadLovers.vue";
import RDStation from "@/components/tools/modals/RDStation.vue";
export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "E-mail marketing",
      subtitle: "Integre suas contas à " + this.$config.get("title")
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Active Campaign",
          image: require("@/assets/images/integrations/active-campaign.svg"),
          description:
            "Integre sua conta da Active Campaign à " +
            this.$config.get("title"),
          modal: ActiveCampaign,
          name: "active-campaign"
        },
        {
          title: "LeadLovers",
          image: require("@/assets/images/integrations/leadlovers.svg"),
          description:
            "Integre sua conta da LeadLovers à " + this.$config.get("title"),
          modal: LeadLovers,
          name: "leadlovers"
        },
        {
          title: "RD Station Marketing",
          image: require("@/assets/images/integrations/rdstation.png"),
          description:
            "Integre sua conta da RD Station Marketing à " +
            this.$config.get("title"),
          modal: RDStation,
          name: "rd-station"
        }
      ];
    }
  }
};
</script>
